import classnames from 'classnames';
import React from 'react';

import { Wrapper } from 'root/widgets/common-components';

import './hide-listing-nudge.scss';
import HideListingNudgeHeader from './sub-components/hide-listing-nudge-header';
import { WrapperProps } from './types';

const HideListingNudge: React.FC<WrapperProps> = ({ metadata, children, className }) => (
  <div {...metadata} className={classnames('hide-listing-nudge-root', className)}>
    {children}
  </div>
);

export default Object.assign(HideListingNudge, {
  Header: HideListingNudgeHeader,
  Body: Wrapper,
  Footer: Wrapper,
});
